module.exports = __webpack_public_path__ + "static/media/25-3.d6c5476c.mp3";